import React from "react";
import { motion } from "framer-motion";

export const Meteors = ({ number = 20, theme = "dark" }) => {
  const isLight = theme === "light";

  // Lightweight, SSR-safe perf detection. We avoid the shared hook here so this
  // module stays plain JS and dependency-light.
  const [perfMode, setPerfMode] = React.useState({ isMobile: false, reduced: false });
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 768px)");
    const rm = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setPerfMode({ isMobile: mq.matches, reduced: rm.matches });
    update();
    mq.addEventListener?.("change", update);
    rm.addEventListener?.("change", update);
    return () => {
      mq.removeEventListener?.("change", update);
      rm.removeEventListener?.("change", update);
    };
  }, []);

  // Cut count hard on mobile; respect reduced-motion entirely.
  const effectiveCount = perfMode.reduced
    ? 0
    : perfMode.isMobile
      ? Math.min(number, 8)
      : number;

  const meteors = React.useMemo(() =>
    new Array(effectiveCount || 0).fill(true).map(() => ({
      left: Math.floor(Math.random() * 100) + "%",
      rotate: 200 + Math.random() * 30,
      animationDelay: Math.random() * (0.8 - 0.2) + 0.2 + "s",
      animationDuration: Math.floor(Math.random() * (10 - 2) + 2) + "s",
    })), [effectiveCount]);

  return (
    <>
      {meteors.map((meteor, idx) => (
        <motion.span
          key={idx}
          className={`pointer-events-none fixed top-0 z-[8] h-0.5 w-0.5 animate-meteor rounded-[9999px] ${
            isLight
              ? "bg-teal-400 shadow-[0_0_0_1px_rgba(20,184,166,0.24)] drop-shadow-[0_0_8px_rgba(20,184,166,0.8)]"
              : "bg-orange-400 shadow-[0_0_0_1px_rgba(251,146,60,0.24)] drop-shadow-[0_0_8px_rgba(249,115,22,0.85)]"
          }`}
          style={{
            top: 0,
            left: meteor.left,
            transform: `rotate(${meteor.rotate}deg)`,
            animationDelay: meteor.animationDelay,
            animationDuration: meteor.animationDuration,
          }}
        >
          <div
            className={`absolute top-0 left-0 h-full w-24 rounded-full ${
              isLight
                ? "bg-gradient-to-r from-teal-500 via-sky-200/80 to-transparent drop-shadow-[0_0_8px_rgba(20,184,166,0.8)]"
                : "bg-gradient-to-r from-orange-500 via-amber-200/80 to-transparent drop-shadow-[0_0_8px_rgba(249,115,22,0.85)]"
            }`}
          ></div>
        </motion.span>
      ))}
    </>
  );
}; 